const search = {
  search: {
    title: 'Lodging available in Urubici',
    sortRecommended: 'Recommended',
    sortPriceLow: 'Lowest price',
    sortPriceHigh: 'Highest price',
    sortRating: 'Best rating',
    available: 'available',
    nightSingular: 'night',
    nightPlural: 'nights',
    guestSingular: 'guest',
    guestPlural: 'guests',
    propertySingular: 'property',
    propertyPlural: 'properties',
    unitSingular: 'unit',
    unitPlural: 'units',
    reviewSingular: 'review',
    reviewPlural: 'reviews',
    changeDates: 'Change dates',
    viewAvailability: 'View availability',
    from: 'from',
    perNightTotal: '/ night · total',
    availableUnitSingular: 'available',
    availableUnitPlural: 'available',
    realTimePrices: 'Real-time prices and availability via Reserve Connect.',
    loadingSearch: 'Searching available lodging...',
    errorTitle: 'Search failed',
    errorMessage: 'The availability service is currently unavailable. Please try again in a few moments.',
    noResultsTitle: 'No lodging available',
    noResultsDesc: 'We could not find properties available for the selected dates.',
    noResultsHint: 'Try changing dates or contact our Reservations Center.',
    pageTitle: 'Lodging available in Urubici - Reserve Connect',
    pageDescription: 'Find lodging available in Urubici, SC from {{checkIn}} to {{checkOut}}. Real prices and confirmed availability.',
    breadcrumbSearch: 'Search',
  },
};
export default search;
